
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/oppo",
      function () {
        return require("private-next-pages/oppo/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/oppo"])
      });
    }
  